"use strict";

require("core-js/modules/es.array.reduce.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _unWidowerText = _interopRequireDefault(require("./unWidowerText"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/**
 *
 * A react component that removes widows from front-end text strings in children.
 * See ./unWidowerText for more info.
 *
 * First the function breaks text into words and counts the length of the string in words
 * Then it counts the length of the last three words and applies either
 * a three word widow break if the words are small enough
 * or a two word widow break if the words are longer
 * but only if the total string length is at least the minimum number of words
 *
 * ! NOTE: Implement this at the lowest possible level in the node tree since it
 * ! iterates through children to find strings and unwidows them. While not that
 * ! expensive, it can become so if implemented on the entire layout, etc.
 *
 * @param {*} children React children node(s)
 * @param {object} [config={
    minWords: 4,
    maxLastWordLength: 9,
    maxPenultWordLength: 4,
    maxAntepenultWordLength: 5,
    maxLastWordLengthTwo: 13,
    maxPenultWordLengthTwo: 11,
  }] the config object
 * * params for three word widow removal, all words must be at most this long
 * @returns
 */


var UnWidowerReactChildren = _react["default"].memo(function (_ref) {
  var children = _ref.children,
      config = _ref.config;
  var defaultConfig = {
    minWords: 4,
    // defaults to 4
    maxLastWordLength: 9,
    // defaults for three-word widow breaker
    maxPenultWordLength: 4,
    // defaults for three-word widow breaker
    maxAntepenultWordLength: 5,
    // defaults for three-word widow-breaker
    maxLastWordLengthTwo: 13,
    // defaults for two-word widow-breaker
    maxPenultWordLengthTwo: 11 // defaults for two-word widow-breaker

  }; // merge passed config with default

  var mergedConfig = _objectSpread({}, defaultConfig, {}, config); // create unWidow function using params (DRY)


  var unWidowString = function unWidowString(string) {
    return (0, _unWidowerText["default"])(string, mergedConfig);
  }; // build iterator function


  var iterate = function iterate(nodes) {
    if (typeof nodes !== "undefined") {
      // if string, simply remove the widows
      if (typeof nodes === "string") {
        return unWidowString(nodes);
      } // iterate array items if array


      if (Array.isArray(nodes)) {
        return nodes.reduce(function (node) {
          return iterate(node);
        });
      } // iterate over object


      if (_typeof(nodes) === "object") {
        // create new object for iterated items
        var newNodes = {}; // loop through object to build new item

        Object.keys(nodes).map(function (key) {
          if (key === "props") {
            newNodes.props = {};
            var props = nodes[key];

            if (typeof props !== "undefined") {
              return Object.keys(props).map(function (prop) {
                if (typeof props[prop] !== "undefined" && prop === "children") {
                  if (Array.isArray(props.children)) {
                    newNodes.props.children = iterate(props.children);
                  }

                  if (_typeof(props.children) === "object") {
                    newNodes.props.children = iterate(props.children);
                  }
                } else {
                  newNodes.props[prop] = props[prop];
                }
              });
            }
          } else {
            newNodes[key] = nodes[key];
          }
        });
        return newNodes;
      }
    }

    return nodes;
  }; // return component


  return _react["default"].Children.map(children, function (child) {
    var unWidowedChild = iterate(child);
    return unWidowedChild;
  });
});

UnWidowerReactChildren.defaultProps = {
  config: null
};
UnWidowerReactChildren.propTypes = {
  children: _propTypes["default"].node.isRequired,
  config: _propTypes["default"].objectOf(_propTypes["default"].number)
};
var _default = UnWidowerReactChildren;
exports["default"] = _default;